module.exports = __webpack_public_path__ + "static/media/7.ecda1ad8.jpg";